import React, { useEffect, useState } from "react";
import {
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import { Droppable } from "./Droppable";
import { Draggable } from "./Draggable";

export default function App({ items }) {

  const containers = ["A", "B", "C", "D"];
  const [parents, setParents] = useState(null);

  useEffect(() => {
    const dragables = items.map((item, idx) => (
      <Draggable id={"item" + (idx + 1)} key={idx} className="bg-white">
        {item}
      </Draggable>
    ));
    setParents({
      item1: {
        parent: "A",
        content: dragables[0],
        correctParent: "E",
        valid: null,
      },
      item2: {
        parent: "B",
        content: dragables[1],
        correctParent: "A",
        valid: null,
      },
      item3: {
        parent: "C",
        content: dragables[2],
        correctParent: "B",
        valid: null,
      },
      item4: {
        parent: "D",
        content: dragables[3],
        correctParent: "C",
        valid: null,
      },
    });
  }, [items]);

  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);

  const sensors = useSensors(mouseSensor, touchSensor);
  return (
    <div className="">
      {parents ? (
        <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
          <div className="d-flex flex-wrap justify-content-center mb-3">
            {Object.keys(parents).map((item, idx) =>
              parents[item].parent === "" ? parents[item].content : null
            )}
          </div>
          <div className="drops-container-4">
            {parents &&
              containers.map((id, idx) => (
                // We updated the Droppable component so it would accept an `id`
                // prop and pass it to `useDroppable`
                <Droppable key={id} id={id}>
                  <div className="border-2 border rounded shadow-sm p-0 card-book">
                    <div className="circle-option btn-blue m-1">{idx + 1}</div>

                    <div className="mh-100">
                      {Object.keys(parents).map((item, idx) =>
                        parents[item].parent === id
                          ? parents[item].content
                          : null
                      )}
                    </div>
                  </div>
                </Droppable>
              ))}
          </div>
        
        </DndContext>
      ) : null}

    
    </div>
  );

  function handleDragEnd(event) {
    const { over } = event;
    if (over) {
      const newParent = over.id;
      const item = event.active.id;
      const oldParent = parents[item].parent;

      let itemsInBox = Object.keys(parents).filter(
        (item) => parents[item].parent === newParent
      )[0];
      setParents({
        ...parents,
        [itemsInBox]: { ...parents[itemsInBox], parent: oldParent },
        [item]: { ...parents[item], parent: newParent },
      });
    }

    // If the item is dropped over a container, set it as the parent
    // otherwise reset the parent to `null`
    //setParent(over ? over.id : null);
  }
}
